var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hover-popover",on:{"mouseenter":_vm.show,"mouseleave":_vm.hide,"focusin":_vm.show,"focusout":_vm.hide}},[_vm._t("default"),(_vm.open)?_c('div',{ref:"panel",staticClass:"md-tooltip hover-popover__panel",class:_vm.popoverClass,style:(_vm.panelStyle)},[_vm._t("content")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }